<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="title"><a id="pagei"></a><a id="pageii"></a><a id="pageiii"></a>A<span class="small">MERICA ON THE</span> B<span class="small">RINK:</span> H<span class="small">OW THE</span><br/> P<span class="small">OLITICAL</span> S<span class="small">TRUGGLE</span> O<span class="small">VER THE</span><br/> W<span class="small">AR OF</span> 1812 A<span class="small">LMOST</span> D<span class="small">ESTROYED THE</span><br/> Y<span class="small">OUNG</span> R<span class="small">EPUBLIC</span></p>
<p class="title1">B<span class="small">Y</span> R<span class="small">ICHARD</span> B<span class="small">UEL</span> J<span class="small">R.</span></p>
<p class="titlelogo"><img alt="" class="inline" src="OEBPS/images/logo.jpg"/> ST. MARTIN’S GRIFFIN <img alt="" class="inline" src="OEBPS/images/logo1.jpg"/> NEW YORK</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?6c824a88